import faker from 'faker'
import { rest } from 'msw'

import type { ApiError } from '@webapp/core/interfaces/api/ApiError'
import { type CreateRequestPayload } from '@webapp/modules/spending-cards/data-access/types/CreateRequestPayload'
import { getResponseObject } from '@webapp/tests'

export const mockCreateRequestSuccess = ({
  payload,
  response = { id: faker.random.number(), uuid: faker.random.uuid() },
}: {
  payload?: CreateRequestPayload
  response?: { id: number; uuid: uuid }
} = {}) => {
  return rest.post(`/api/v4/pay/requests/`, (request, res, ctx) => {
    if (payload) {
      for (const param in payload) {
        if (Array.isArray(payload[param])) {
          for (const item of payload[param]) {
            if (request.body[param][item] !== payload[param][item]) {
              return res(ctx.status(400))
            }
          }
        } else if (request.body[param] !== payload[param]) {
          return res(ctx.status(400))
        }
      }
    }

    return res.once(ctx.status(201), ctx.json(getResponseObject(response)))
  })
}

export const mockCreateRequestError = (
  errResponse: Nullable<Partial<ApiError>> = null
) => {
  return rest.post(`/api/v4/pay/requests/`, (_, res, ctx) => {
    return res.once(ctx.status(400), ctx.json(errResponse))
  })
}
